<!--
  Stat cards keep one fixed width and wrap, every row as tall as the tallest card; a full-width section (e.g. the Products or Vendors charts)
  keeps the panel a single stretching column.
-->
<div
  class="grid gap-lg [grid-template-columns:repeat(auto-fill,14rem)] auto-rows-fr [&>*]:h-full [&_lib-stat]:block [&_lib-stat]:h-full [&:has(>.col-span-full)]:[grid-template-columns:minmax(0,1fr)] [&:has(>.col-span-full)]:auto-rows-auto">
  <ng-content />
</div>
